import { useCallback, useEffect, useRef, useState } from 'react';
import {
  getPostLanguage,
  getSpentTime,
  getUserDetailsNew,
  setCurrentUser,
} from '../services/authService';
import { useSnackBar } from '../hooks/snackBarHooks';
import { useStoreActions, useStoreState } from 'easy-peasy';
import gWW from '../services/gWW';
import { makeStyles } from '@material-ui/core';
import { getCurrentUser } from '../services/httpService';
import { useHistory } from 'react-router-dom';
import { urlMap } from '../utils/constants';
import { useLastLocation } from 'react-router-last-location';
import { getPreviousLocation, screenNamesSet } from '../utils/screenUtils';
import MoengageService from '../services/moEngageService';
import { useNavBar } from './navBarHooks';
import language from '../utils/languages';

function manageBtn(lecture, type, progress) {
  const isAttemptedQuiz =
    lecture?.quiz && lecture?.quiz[0] && lecture?.quiz[0].isAttempted;
  const isAttemptedSurvey = lecture?.survey.isAttempted;
  if (!lecture?.quiz && lecture?.survey.length === 0) {
    //check if both data not available
    return `${'askBtn'} ${'btnWidth100'}`;
  } else if (lecture?.quiz && lecture?.survey.length !== 0) {
    //check if survey and quiz data available
    if (type === 'askQuestionType') {
      return `${'askBtn'} ${'btnWidth33'}`;
    } else if (
      (isAttemptedQuiz && type === 'assignmentType') ||
      (isAttemptedSurvey && type === 'surveyType')
    ) {
      return `${'greyBtn'} ${'btnWidth33'}`;
    } else if (progress <= 30 && (!isAttemptedQuiz || !isAttemptedSurvey)) {
      return `${'greyBtn'} ${'btnWidth33'}`;
    } else {
      return `${'assignmentBtn'} ${'btnWidth33'}`;
    }
  } else if (!lecture?.quiz && lecture?.survey.length !== 0) {
    //check if survey and not quiz data available
    if (type === 'askQuestionType') {
      return `${'askBtn'} ${'btnWidth2'}`;
    } else if (
      (isAttemptedQuiz && type === 'assignmentType') ||
      (isAttemptedSurvey && type === 'surveyType')
    ) {
      return `${'greyBtn'} ${'btnWidth2'}`;
    } else if (progress <= 30 && (!isAttemptedQuiz || !isAttemptedSurvey)) {
      return `${'greyBtn'} ${'btnWidth2'}`;
    } else {
      return `${'assignmentBtn'} ${'btnWidth2'}`;
    }
  } else if (lecture?.quiz && lecture?.survey.length === 0) {
    //check if not survey and quiz data available
    if (type === 'askQuestionType') {
      return `${'askBtn'} ${'btnWidth2'}`;
    } else if (
      (isAttemptedQuiz && type === 'assignmentType') ||
      (isAttemptedSurvey && type === 'surveyType')
    ) {
      return `${'greyBtn'} ${'btnWidth2'}`;
    } else if (progress <= 30 && (!isAttemptedQuiz || !isAttemptedSurvey)) {
      return `${'greyBtn'} ${'btnWidth2'}`;
    } else {
      return `${'assignmentBtn'} ${'btnWidth2'}`;
    }
  }
}

function useVideoPlayerOptions({
  lecture,
  nextUnWatchedLectureId,
  playerRef,
  controlsRef,
  playBtnRef,
  count,
  setNextUnWatchedLectureId,
  setProgress,
  progress,
}) {
  let lectureData = useStoreState((state) => state.lecture.lectureData);
  const setToastMessage = useSnackBar();
  const [isReady, setIsReady] = useState(false);
  const language = getPostLanguage();
  const [timeDisplayFormat, setTimeDisplayFormat] = useState('normal');

  const [state, setState] = useState({
    pip: false,
    playing: lecture.id === nextUnWatchedLectureId ? true : false,
    controls: false,
    light: false,
    muted: true,
    played: 0,
    playbackRate: 1.0,
    volume: 1,
    loop: false,
    seeking: false,
  });
  const handlePlayPause = () => {
    setState({ ...state, playing: !state.playing });
  };

  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
  };

  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
  };

  async function videoStatusUpdate(lectureId, progress) {
    try {
      await gWW.updateVideoStatus(
        lectureId,
        progress,
        language,
        setToastMessage
      );
    } catch (e) {
      console.log(e);
    }
  }

  function handleOnEnded(lecture) {
    videoStatusUpdate(lecture?.id);
    setNextUnWatchedLectureId(lecture?.nextLectureId);
  }

  const handleProgress = (e, lecture, changeState) => {
    setProgress(parseInt(e.playedSeconds.toFixed(2)));
    videoStatusUpdate(lecture?.id, progress);

    if (count > 3) {
      controlsRef.current.style.visibility = 'hidden';
      count = 0;
    }
    if (controlsRef.current.style.visibility === 'visible') {
      count += 1;
    }
    if (!state.seeking) {
      setState({ ...state, ...changeState });
    }
  };

  const onReady = useCallback(() => {
    if (!isReady) {
      const timeToStart = lectureData && lectureData?.videoWatchTime;
      playerRef.current.seekTo(timeToStart);
      setIsReady(true);
    }
    // eslint-disable-next-line
  }, [isReady, lectureData]);

  const handleSeekChange = (e, newValue) => {
    setState({ ...state, played: parseFloat(newValue / 100) });
  };

  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };

  const handleSeekMouseUp = (e, newValue) => {
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue / 100, 'fraction');
  };

  const handleVolumeSeekDown = (e, newValue) => {
    setState({ ...state, seeking: false, volume: parseFloat(newValue / 100) });
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };

  const handleMouseMove = () => {
    controlsRef.current.style.visibility = 'hidden';
    playBtnRef.current.style.visibility = 'hidden';
    count = 0;
  };

  const handleMouseLeave = () => {
    controlsRef.current.style.visibility = 'hidden';
    playBtnRef.current.style.visibility = 'hidden';
    count = 0;
  };

  const handleDisplayFormat = () => {
    setTimeDisplayFormat(
      timeDisplayFormat === 'normal' ? 'remaining' : 'normal'
    );
  };

  const handlePlaybackRate = (rate) => {
    setState({ ...state, playbackRate: rate });
  };

  const hanldeMute = () => {
    setState({ ...state, muted: !state.muted });
  };

  const useStyles = makeStyles((theme) => ({
    playIcon: {
      position: 'absolute',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      visibility: 'hidden',
      top: '40%',
      '& button': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        border: '1px solid #fff',
        color: ' #fff',
      },
    },
    controlsWrapper: {
      visibility: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.4)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    topControls: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing(2),
    },
    middleControls: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    bottomWrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(2),
    },
    bottomControls: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    button: {
      margin: theme.spacing(1),
    },
    controlIcons: {
      color: '#777',
      fontSize: 50,
      transform: 'scale(0.9)',
      '&:hover': {
        color: '#fff',
        transform: 'scale(1)',
      },
    },
    bottomIcons: {
      color: '#999',
      '&:hover': {
        color: '#fff',
      },
    },
    volumeSlider: {
      width: 100,
    },
    volumeIcon: {
      padding: theme.spacing(4.5),
      position: 'absolute',
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      height: '50vh',
      bottom: '5px',
      '& button': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        border: '1px solid #fff',
        color: ' #fff',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
        },
      },
    },
  }));
  const classes = useStyles();

  const format = (seconds) => {
    if (isNaN(seconds)) {
      return `00:00`;
    }
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds().toString().padStart(2, '0');
    if (hh) {
      return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`;
    }
    return `${mm}:${ss}`;
  };

  return {
    classes,
    state,
    timeDisplayFormat,
    format,
    handleSeekChange,
    handleSeekMouseDown,
    hanldeMute,
    handleSeekMouseUp,
    handleRewind,
    handlePlayPause,
    handleFastForward,
    handleProgress,
    handleOnEnded,
    handleVolumeSeekDown,
    handleVolumeChange,
    handlePlaybackRate,
    handleDisplayFormat,
    onReady,
    handleMouseMove,
    handleMouseLeave,
  };
}

function useWomenWillVideo({ lectureData, post }) {
  const history = useHistory();
  const { setLectureData } = useStoreActions((actions) => actions.lecture);
  const webLanguage = getPostLanguage();
  const [showCTAButton, setShowCTAButton] = useState();
  const fromIsChapter = history?.location?.state?.fromIsChapter;
  const currentUser = getCurrentUser();
  const snackBar = useSnackBar();
  const config = {
    attributes: {
      disablePictureInPicture: true,
      controlsList: 'noplaybackrate nodownload',
    },
  };
  const isBonus = lectureData?.isBonus;
  const lectureId = lectureData && lectureData.lectureId;
  const [progress, setProgress] = useState(0.0);
  const [isReady, setIsReady] = useState(false);
  const setToastMessage = useSnackBar();
  const playerRef = useRef();
  const isQuizAttempted =
    lectureData && lectureData.quiz[0] && lectureData.quiz[0].isAttempted;
  const [videoStatus, setVideoStatus] = useState();
  const status = videoStatus && videoStatus.status;
  const isQuiz = lectureData && lectureData.quiz[0] && lectureData.quiz[0];
  const [disabled, setDisabled] = useState(true);
  const chapterId = post && post.id;
  async function videoStatusUpdate(lectureId, progress) {
    try {
      const response = await gWW.updateVideoStatus(
        lectureId,
        progress,
        webLanguage,
        setToastMessage
      );
      response && setVideoStatus(response);
      if (response && response.isCourseComplete) {
        // when user is on last video and course gets complete, then update the key in user object.
        await getUserDetailsNew({ fromGwwScreen: true });
      }
      if (response && response.certificate) {
        // when user has watched 13 videos need to check certificate
        await getUserDetailsNew({ fromGwwScreen: true });
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
    }
  }
  const handleSeek = (e) => {
    const seek = parseInt(e);
    seek >= lectureData.minCompleteDuration &&
      lectureId &&
      videoStatusUpdate(lectureId, progress);
  };
  const handleTakeQuiz = () => {
    const quizData = { ...lectureData };
    if (quizData?.quiz === null || quizData?.quiz === undefined) {
      if (quizData?.isBonus) {
        history.push(urlMap.LEARN_TAB);
      } else {
        history.push(urlMap.COURSE_TAB);
      }
    } else {
      history.push(lectureData.quizUrl, { quizData, status, chapterId });
    }
  };

  const handleNextVideo = () => {
    history.push(lectureData?.nextLectureUrl);
  };

  function onProgressStatus(e) {
    setProgress(parseInt(e.playedSeconds.toFixed(2)));
    lectureData?.minCompleteDuration === progress &&
      lectureId &&
      videoStatusUpdate(lectureId, progress);
  }

  function onEnded(lectureId) {
    lectureId && videoStatusUpdate(lectureId, progress);
  }
  function handleClick() {
    if (isQuiz === undefined && !lectureData?.nextLectureUrl) {
      history.push(urlMap.COURSE_TAB);
    } else if (isQuiz === undefined && lectureData?.nextLectureUrl) {
      handleNextVideo();
    } else if (isQuizAttempted === false) {
      handleTakeQuiz();
    } else if (lectureData?.status === 'Complete') {
      handleTakeQuiz();
    } else if (status !== 'SUCCESS') {
      snackBar('Watch the video for minimum 30 seconds.');
    } else if (lectureData && lectureData.quiz && lectureData.quiz[0]) {
      handleTakeQuiz();
    } else {
      handleNextVideo();
    }
    lectureId && videoStatusUpdate(lectureId, progress);
  }

  const onReady = useCallback(() => {
    if (!isReady) {
      const timeToStart =
        progress !== 0 && fromIsChapter
          ? progress
          : lectureData?.videoWatchTime;
      playerRef.current.seekTo(timeToStart);
      setIsReady(true);
    }
  }, [isReady, lectureData, progress, fromIsChapter]);

  useEffect(() => {
    if (
      progress >= lectureData?.minCompleteDuration ||
      status === 'SUCCESS' ||
      lectureData?.status === 'Complete'
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    post.lecture && setLectureData(post && post.lecture && post.lecture[0]);
    window.onbeforeunload = function () {
      lectureId &&
        gWW.updateVideoStatus(
          lectureId,
          progress,
          webLanguage,
          setToastMessage
        );
    };

    if (fromIsChapter) {
      setShowCTAButton(false);
    }
    if (
      (!currentUser?.isCourseComplete && isBonus) ||
      !currentUser?.isCourseComplete ||
      isBonus
    ) {
      // is course not complete:-
      setShowCTAButton(true);
    }

    //for updated course tab and view certificate page
    if (currentUser?.isCourseComplete) {
      if (post?.showActionsPostCompletion) {
        setShowCTAButton(true);
      } else {
        setShowCTAButton(false);
      }
    }
    // eslint-disable-next-line
  }, [lectureId, progress, lectureData, setDisabled]);

  return {
    playerRef,
    onProgressStatus,
    handleSeek,
    onReady,
    config,
    lectureId,
    onEnded,
    handleClick,
    disabled,
    showCTAButton,
  };
}

function useCertificate({ decodeCourseId, decodeUserId }) {
  const [download, setDownload] = useState({
    imageDownload: '',
    langDownloadEnabled: '',
  });
  const webLanguage = getPostLanguage();
  const languageText = language[webLanguage ? webLanguage : 'en'];
  const setToastMessage = useSnackBar();
  const spentTime = getSpentTime();
  const lastLocation = useLastLocation();
  const source = getPreviousLocation(lastLocation);
  const currentUser = getCurrentUser();
  const screenName = screenNamesSet.viewCertificate;

  MoengageService.trackViewCertificate(
    source,
    screenName,
    spentTime,
    currentUser && currentUser.courseId,
    webLanguage,
    currentUser && currentUser.userType
  );

  useNavBar({
    title: languageText?.WOMENWILL_CERTIFICATE,
    hideNavBar: false,
    disableCustomSideBarGrid: false,
    showBack: false,
    showWomenWillCourse: true,
  });
  async function viewCertificate() {
    const data = await gWW
      .viewCertificate(decodeUserId, decodeCourseId, setToastMessage)
      .then((res) => {
        setDownload({
          imageDownload: res?.certificate?.url,
          langDownloadEnabled: res?.langDownloadEnabled,
        });
      });
    return data;
  }

  useEffect(() => {
    viewCertificate();
    // eslint-disable-next-line
  }, []);

  async function fetchImage() {
    const image = await fetch(download.imageDownload);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement('a');
    link.href = imageURL;
    link.download = 'WomenWill certificate.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (image.status === 200) {
      const updatedUser = { isCertificateDownload: true };
      setCurrentUser({ ...currentUser, ...updatedUser });
      MoengageService.trackCertificateDownload(
        currentUser?.currentLanguage,
        download && download.imageDownload
      );
    }
  }
  const useStyles = makeStyles(() => ({
    partText: {
      margin: '2%',
    },
    main: {
      backgroundColor: 'white',
      padding: '4%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      lineHeight: '25px',
      textAlign: 'center',
    },
    bltText: {
      padding: '4%',
    },
    viewBtn: {
      backgroundColor: '#019d53',
      borderRadius: '24px',
      color: 'white',
      marginTop: '16px',
      boxShadow:
        '0px 3px 1px -2px rgb(0 0 0 / 16%), 0px 2px 2px 0px rgb(0 0 0 / 20%), 0px 1px 5px 0px rgb(0 0 0 / 8%)',
      '&:hover': {
        backgroundColor: '#019d53',
        color: 'white',
        boxShadow:
          '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
      },
    },
    head: {
      display: 'flex',
      justifyContent: 'end',
      width: '100%',
    },
    righthead: {
      display: 'flex',
      gap: '17px',
      marginLeft: '323px',
      cursor: 'pointer',
    },
    downloadIcon: {
      color: 'white',
    },
  }));
  const classes = useStyles();

  return { fetchImage, download, classes };
}

export { manageBtn, useVideoPlayerOptions, useWomenWillVideo, useCertificate };
